type ActiveBarProps = { isActive: boolean };

export function ActiveBar({ isActive }: ActiveBarProps) {
    if (!isActive) return null;
    return (
        <span className="absolute -bottom-[11px] left-1/2 h-0.5 w-5 -translate-x-1/2 bg-icoBlue" />
    );
}
